export const AutoSyncDataLayerSymbol = Symbol.for("AutoSyncDataLayer");
